module.exports = __webpack_public_path__ + "106bcd2c57a24c019f72a37c8f766be0.svg";